import "./AboutUs.css";
import { Linkedin, Github, Globe } from "lucide-react";

const team = [
  {
    name: "Renovation AI Design",
    role: "Co-founder",
    tagline: "Fighting one pixel at a time",
    img: "/RenovativeDesign_logo.png",
    website: "https://renovative.design",
    linkedin: "https://www.linkedin.com/company/renovative-design-ai",
    github: null
  },
  {
    name: "Milad Amiri",
    role: "CEO",
    tagline: "Building the future of Urban Intelligence",
    img: "/milad.jpg",
    website: "https://munarch.ca",
    linkedin: "https://linkedin.com/in/milad-amiri",
    github:null
  },
  {
    name: "Zahra Zaman",
    role: "COO",
    tagline: "Turning ideas into structured execution",
    img: "/Foroogh.jpg",
    website: "https://munarch.ca",
    linkedin: "https://www.linkedin.com/in/foroogh-zaman-revit-architect/",
    github: null
  },
  {
    name: "Akbar Disfani",
    role: "Head of science",
    tagline: "Architecting data-driven cities",
    img: "/akbar.jpg",
    website: null,   // ❌ no website → we will NOT render globe icon
    linkedin: null,
    github: null
  }
];

export default function AboutUs() {
  return (
    <div className="about-container">
      <h2 className="about-title">Meet Our Team</h2>

      <div className="team-grid">
        {team.map((member, idx) => (
          <div className="team-card" key={idx}>
            <div className="image-frame">
              <img src={member.img} alt={member.name} />
            </div>

            <div className="team-info">
              <p className="role">{member.role}</p>
              <h3 className="name">{member.name}</h3>
              <p className="tagline">{member.tagline}</p>

              <div className="social-row">
                
                {member.linkedin && (
                  <a href={member.linkedin} target="_blank" rel="noopener noreferrer">
                    <Linkedin size={20} />
                  </a>
                )}

                {member.github && (
                  <a href={member.github} target="_blank" rel="noopener noreferrer">
                    <Github size={20} />
                  </a>
                )}

                {member.website && (
                  <a href={member.website} target="_blank" rel="noopener noreferrer">
                    <Globe size={20} />
                  </a>
                )}

              </div>

            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
